import { driverStore } from './model';

// eslint-disable-next-line import/prefer-default-export
export const getDriverStore = driverStore;
